<script>
export default {
    inject: ['levelSelect'],
    computed: {
        activeName() {
            return this.levelSelect.store.activeTab.label;
        }
    },
    watch: {
        activeName() {
            const { store } = this.levelSelect;
            this.$nextTick(() => {
                store.tabsData = store.setTabsData(store.optData);
                store.initOptionsData();
                store.initCount();
            });
        }
    },
    methods: {
        handleClick(item) {
            this.changeActiveName(item);
            this.$nextTick(() => {
                this.$emit('change', item);
                this.levelSelect.emitTabChange(item);
            });
        },
        changeActiveName(item) {
            this.levelSelect.store.setActiveTab(item);
        }
    },
    render(h) {
        return (
            <div class="filter-tabs">
                {this.levelSelect.tabConfig.map(item => {
                    return (
                        <div class={`tab-wrapper ${this.activeName === item.label ? 'is-active' : ''}`} key={item.label} onClick={() => this.handleClick(item)}>
                            {item.render ? item.render(h, this.levelSelect.store.activeTab) : item.label}
                        </div>
                    );
                })}
            </div>
        );
    }
};
</script>
<style lang="scss" scoped>
@import '../../styles/common/var.scss';
.filter-tabs {
    display: flex;
    justify-content: space-around;
    margin: 0 10px;
    position: relative;
    font-size: 13px;
    font-weight: 500;
    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: #e4e7ed;
        z-index: 1;
    }
    .tab-wrapper {
        position: relative;
        z-index: 2;
        padding: 5px;
        cursor: pointer;
        box-sizing: border-box;
        &:hover {
            color: $--color-primary;
        }
        &.is-active {
            color: $--color-primary;
            border-bottom: 2px solid $--color-primary;
        }
    }
}
</style>
